import React from 'react';
export function Navbar() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <nav className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-md z-40 border-b border-emerald-50 shadow-sm" data-id="element-88">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="flex justify-between items-center h-16" data-id="element-90">
          <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={e => scrollToSection(e as any, 'hero')} data-id="element-91">
            <span className="font-bold text-xl text-emerald-800" data-id="element-92">
              Sistema PRO
            </span>
          </div>
          <div className="hidden md:flex space-x-8 items-center" data-id="element-93">
            <a href="#hero" onClick={e => scrollToSection(e, 'hero')} className="text-gray-600 hover:text-emerald-600 font-medium transition-colors" data-id="element-94">
              Sistema PRO: Pediatría
            </a>
            <a href="#bonos" onClick={e => scrollToSection(e, 'bonos')} className="text-gray-600 hover:text-emerald-600 font-medium transition-colors" data-id="element-95">
              Bonos
            </a>
            <a href="#testimonios" onClick={e => scrollToSection(e, 'testimonios')} className="text-gray-600 hover:text-emerald-600 font-medium transition-colors" data-id="element-96">
              Testimonios
            </a>
            <a href="#comprar" onClick={e => scrollToSection(e, 'comprar')} className="bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2 rounded-full font-semibold transition-colors shadow-md hover:shadow-lg" data-id="element-97">
              Comprar Ahora
            </a>
          </div>
        </div>
      </div>
    </nav>;
}